export const apportionablesModalSelector = state => state.apportionables.apportionablesModal;

export const apportionablesResourceSelector = state =>
  apportionablesModalSelector(state).displayApportionmentModal;
